export default "__VITE_ASSET__68945bb9__"